import { useState, ReactNode } from 'react';
import { Menu } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Sidebar } from './Sidebar';

interface MobileSidebarDrawerProps {
  variant?: 'funcionarios' | 'oposiciones';
  trigger?: ReactNode;
  /** Class for the trigger wrapper. Defaults to fixed top-left. */
  triggerClassName?: string;
}

/**
 * Mobile-only drawer that wraps the existing <Sidebar />.
 * On md+ screens this component renders nothing — the sidebar is shown inline
 * by the parent layout.
 */
export function MobileSidebarDrawer({
  variant = 'funcionarios',
  trigger,
  triggerClassName,
}: MobileSidebarDrawerProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className={triggerClassName ?? 'md:hidden'}>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          {trigger ?? (
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              aria-label="Abrir menú"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}
        </SheetTrigger>
        <SheetContent
          side="left"
          className={`p-0 w-[280px] max-w-[85vw] ${variant === 'oposiciones' ? 'oposiciones-sidebar' : ''}`}
          onClick={(e) => {
            // Close drawer when an internal link/button is clicked
            const target = e.target as HTMLElement;
            if (target.closest('a, button')) setOpen(false);
          }}
        >
          <Sidebar variant={variant} />
        </SheetContent>
      </Sheet>
    </div>
  );
}
